export const AllLatestEvents = 'allLatestEvents';
export const NewEventEmittedEvent = 'newEventEmitted';
export const SessionEventsReplayedEvent = 'sessionEventsReplayed';
